import React from 'react';
import service1 from '../images/1.jpg';
import service2 from '../images/2.jpg';
import service3 from '../images/3.jpg';

const servicesData = [
  {
    id: 1,
    number: "01",
    icon: "🔍",
    image: service1,
    title: "Comprehensive Service Investigation",
    description: "We offer comprehensive service investigation/inspections for your businesses ensuring thorough compliance and safety standards are met.",
    details: [
      "Thorough on-site safety inspections and audits",
      "Identification of potential hazards and risks",
      "Detailed reports with prioritized recommendations",
      "Compliance checks against latest HSE regulations",
      "Follow-up support to ensure improvements are implemented"
    ]
  },
  {
    id: 2,
    number: "02",
    icon: "📊",
    image: service2,
    title: "Professional Reviews & Advice",
    description: "We offer reviews of your findings of all types of businesses and how you can improve these with professional advice and actionable insights.",
    details: [
      "Expert review of your existing safety documentation",
      "Analysis of accident and incident reports",
      "Actionable insights to improve safety culture",
      "Strategic advice for long-term safety management",
      "Guidance on best practices within your specific industry"
    ]
  },
  {
    id: 3,
    number: "03",
    icon: "🤝",
    image: service3,
    title: "Business Support Services",
    description: "We help and advise large and small businesses with tailored safety solutions that fit your specific industry needs and requirements.",
    details: [
      "Tailored safety management systems for SMEs",
      "Ongoing support for large-scale operations",
      "Assistance with safety accreditations (e.g., CHAS, SafeContractor)",
      "Employee safety training and awareness workshops",
      "Emergency planning and response coordination"
    ]
  }
];

const Services = () => {
  const [selectedService, setSelectedService] = React.useState(null);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openModal = (service) => {
    setSelectedService(service);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedService(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <section id="services" className="services-section">
      <div className="services-container">
        <div className="section-header">
          <div className="section-badge">Our Services</div>
          <h2 className="section-title">
            "What Be Safe Keep Safe can do for You?"
          </h2>
          <p className="section-subtitle">
            We provide comprehensive safety solutions tailored to your business needs, 
            ensuring compliance and creating safer work environments.
          </p>
        </div>

        <div className="services-grid">
          {servicesData.map((service) => (
            <div key={service.id} className="service-card">
              <div className="service-image-container">
                <img src={service.image} alt={service.title} className="service-image" />
                <div className="service-number">{service.number}</div>
              </div>
              <div className="service-content">
                <div className="service-icon">{service.icon}</div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <button 
                  className="btn-read-more"
                  onClick={() => openModal(service)}
                >
                  Read More <span>→</span>
                </button>
              </div>
            </div>
          ))}
        </div>

        {selectedService && (
          <div className="service-modal-overlay" onClick={closeModal}>
            <div className="service-modal" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={closeModal}>&times;</button>
              <div className="modal-body">
                <div className="modal-image">
                  <img src={selectedService.image} alt={selectedService.title} />
                </div>
                <div className="modal-content">
                  <span className="modal-badge">Service {selectedService.number}</span>
                  <h3>{selectedService.title}</h3>
                  <p className="modal-desc">{selectedService.description}</p>
                  <div className="modal-details">
                    <h4>What's included:</h4>
                    <ul>
                      {selectedService.details.map((detail, idx) => (
                        <li key={idx}>{detail}</li>
                      ))}
                    </ul>
                  </div>
                  <button 
                    className="btn-primary" 
                    onClick={() => {
                      closeModal();
                      scrollToSection('contact');
                    }}
                  >
                    Inquire About This Service
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="services-cta">
          <button 
            className="btn-primary btn-learn-more"
            onClick={() => scrollToSection('contact')}
          >
            Get a Free Quote Now
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
